import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ScreenProvider } from "./context/ScreenContext";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./pages/Home";
import Services from "./pages/Services";
import MedicalDirectory from "./pages/MedicalDirectory";
import DoctorsDetails from "./pages/DoctorsDetails";
import Location from "./pages/Location";
import VisionMission from "./pages/VisionMission";
import FrequentlyQuestions from "./pages/FrequentlyQuestions";
import InsuranceCompanies from "./pages/InsuranceCompanies";
import ContactDoctors from "./pages/ContactDoctors";
import TermsOfUse from "./pages/TermsOfUse";
import SitePolicies from "./pages/SitePolicies";
import ComprehensivePrivacy from "./pages/ComprehensivePrivacy";
import ScrollToTop from "./pages/ScrollToTop";
// const Home = lazy(() => import("./Views/Home"));
// import JoinMEDAM from "./pages/JoinMEDAM";
// import Newsletter from "./pages/Newsletter";
// import PackagesSpecial from "./pages/PackagesSpecial";
// import PreRegistration from "./pages/PreRegistration";

const App = () => {
  return (
    <ScreenProvider>
      <Navbar />
      <ScrollToTop />
      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/medicalDirectory" element={<MedicalDirectory />} />
          <Route path="/location" element={<Location />} />
          <Route path="/doctorsDetails" element={<DoctorsDetails />} />
          <Route path="/visionMission" element={<VisionMission />} />
          <Route
            path="/frequentlyQuestions"
            element={<FrequentlyQuestions />}
          />
          <Route path="/insuranceCompanies" element={<InsuranceCompanies />} />
          <Route path="/contactDoctors" element={<ContactDoctors />} />
          <Route path="/termsOfUse" element={<TermsOfUse />} />
          <Route path="/sitePolicies" element={<SitePolicies />} />
          <Route
            path="/comprehensivePrivacy"
            element={<ComprehensivePrivacy />}
          />
          {/* <Route path="/packagesSpecial" element={<PackagesSpecial />} /> */}
          {/* <Route path="/preRegistration" element={<PreRegistration />} /> */}
          {/* <Route path="/newsletter" element={<Newsletter />} /> */}
          {/* <Route path="/joinMEDAM" element={<JoinMEDAM />} /> */}
        </Routes>
      </Suspense>
    </ScreenProvider>
  );
};

export default App;
